export enum LineDirection {
  TOP = 'Top',
  BOTTOM = 'Bottom',
  LEFT = 'Left',
  RIGHT = 'Right',
  VERTICAL_LEFT = 'V_LEFT',
  VERTICAL_RIGHT = 'V_RIGHT',
}
